module.exports = {"440105001":"赤岗街道","440105002":"新港街道","440105003":"昌岗街道","440105004":"江南中街道","440105005":"滨江街道","440105006":"素社街道","440105007":"海幢街道","440105008":"南华西街道","440105009":"龙凤街道","440105010":"沙园街道","440105011":"南石头街道","440105012":"凤阳街道","440105013":"瑞宝街道","440105014":"江海街道","440105015":"琶洲街道","440105016":"南洲街道","440105017":"华洲街道","440105018":"官洲街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440105.json
// module id = 2073
// module chunks = 0